export const PrintSuccess = (message: string) => {
    const toast = useToast()
    toast.add({ title: message, color: 'success', duration: 3000 })
}

export const PrintError = (message: string) => {
    const toast = useToast()
    toast.add({ title: message, color: 'error', duration: 5000 })
}

/**
 * Something the person should know that is not a fault.
 *
 * A publish that went through without the photographs is not an error — the hotel's
 * description reached the channel — but it is not a success either, and drawing it in
 * red taught the desk to read successes as failures.
 */
export const PrintWarning = (message: string) => {
    const toast = useToast()
    toast.add({ title: message, color: 'warning', duration: 6000 })
}
